export const widgetTypes = {
  FETCH_WIDGET_INFO_START: 'FETCH_WIDGET_INFO_START',
  SET_WIDGET_INFO: 'SET_WIDGET_INFO',
  SET_ACTIVE_TRIGGER_MESSAGE: 'SET_ACTIVE_TRIGGER_MESSAGE',
  SET_SHOW_WIDGET: 'SET_SHOW_WIDGET',
  SET_SHOW_LAUNCHER: 'SET_SHOW_LAUNCHER',
  SET_SHOW_TRIGGER: 'SET_SHOW_TRIGGER',
  SET_LAUNCHER_CONTENT: 'SET_LAUNCHER_CONTENT',
  SET_HEADER_EXPAND: 'SET_HEADER_EXPAND',
  SET_ANIMATE_WIDGET: 'SET_ANIMATE_WIDGET',
  SET_OFFICE_HOURE: 'SET_OFFICE_HOURE',
  SET_DISABLE_TRIGGER_MESSAGES: 'SET_DISABLE_TRIGGER_MESSAGES',
  SET_DEPARTMENT: 'SET_DEPARTMENT',
  TOGGLE_LAUNCHER: 'TOGGLE_LAUNCHER',
  SET_WIDGET_READY: 'SET_WIDGET_READY',
  SET_WIDGET_SIZE_WIDE_OPEN: 'SET_WIDGET_SIZE_WIDE_OPEN',
  SET_WIDGET_TAB: 'SET_WIDGET_TAB',
  SET_HELP_TAB_STATE: 'SET_HELP_TAB_STATE',
  SET_HELP_TAB_FAQ: 'SET_HELP_TAB_FAQ',
  SET_HELP_TAB_INPUT_FOCUS: 'SET_HELP_TAB_INPUT_FOCUS',
  SET_INJECTED_STYLES: 'SET_INJECTED_STYLES',
  SET_INJECTED_POSITION: 'SET_INJECTED_POSITION',
  SET_AUTO_MESSAGE_SIZE: 'SET_AUTO_MESSAGE_SIZE',
  SET_FORMS: 'SET_FORMS',
  SET_MESSENGER_TAB_STATE: 'SET_MESSENGER_TAB_STATE',
  SET_HEADER_EXPANDED_HEIGHT: 'SET_HEADER_EXPANDED_HEIGHT',
  SET_WIDGET_ICON_VISIBLE: 'SET_WIDGET_ICON_VISIBLE',
}
